import React from "react";
import preview from "../assets/images/preview.png"

function Download() {
    return (
        <section id="download">
            <div className="container">
                <div className="section-text">
                    <div className="section-text__title text-white">
                        Our App will be Available soon For Android Device
                    </div>
                    <div className="section-text__body text-white">

                    </div>
                </div>
                <div className="section-image">
                    <img src={preview} alt="download" />
                </div>
            </div>
        </section>
    );
}

export default Download;
